import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// 导入全局样式
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css';
import './plugins/element-ui.js';
// 导入字体图标
import './assets/fonts/iconfont.css';

// 导入axios
import Axios from './plugins/axios.js';

// elementui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(ElementUI, {locale})


// 挂载到vue的原型对象上
Vue.prototype.$http = Axios;

Vue.config.productionTip = false;

// 监听浏览器的前进后退
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL);
});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
